module.exports = __webpack_public_path__ + "img/404.ab723bca.png";